import { Asset } from "@storytell/cp-client";
import type { AssetLifecycleState } from "@storytell/types";

export const lifecycleStateToString = (state: Asset.AssetLifecycleState) => {
  switch (state) {
    case Asset.AssetLifecycleState.UNSPECIFIED:
      return "Unspecified";
    case Asset.AssetLifecycleState.AWAITING_UPLOAD:
      return "Awaiting Upload";
    case Asset.AssetLifecycleState.UPLOADED:
      return "Uploaded";
    case Asset.AssetLifecycleState.QUEUED_FOR_PROCESSING:
      return "Queued for Processing";
    case Asset.AssetLifecycleState.PROCESSING:
      return "Processing";
    case Asset.AssetLifecycleState.READY:
      return "Ready";
    case Asset.AssetLifecycleState.FAILED:
      return "Failed";
    case Asset.AssetLifecycleState.REPROCESSING:
      return "Reprocessing";
    case Asset.AssetLifecycleState.ARCHIVED:
      return "Archived";
    case Asset.AssetLifecycleState.QUARANTINED:
      return "Quarantined";
    case Asset.AssetLifecycleState.DELETE_REQUESTED:
      return "Delete Requested";
    case Asset.AssetLifecycleState.DELETED:
      return "Deleted";
    case Asset.AssetLifecycleState.TOO_MANY_REQUESTS:
      return "Insufficient Credits";
  }
};

export const lifecycleStateGrouped = (state: AssetLifecycleState) => {
  switch (state) {
    case "AWAITING_UPLOAD":
      return "uploading";
    case "UPLOADED":
    case "QUEUED_FOR_PROCESSING":
      return "processing";
    case "PROCESSING":
      return "processing";
    case "READY":
      return "ready";
    case "FAILED":
      return "error";
    case "REPROCESSING":
      return "processing";
    case "DELETED":
      return "deleted";
    case "TOO_MANY_REQUESTS":
      return "insufficient credits";
    // TODO: @andi Handle other states
    default:
      return "";
  }
};

export const lifecycleStateToShort = (state: Asset.AssetLifecycleState) => {
  switch (state) {
    case Asset.AssetLifecycleState.UNSPECIFIED:
      return "";
    case Asset.AssetLifecycleState.AWAITING_UPLOAD:
      return "uploading";
    case Asset.AssetLifecycleState.UPLOADED:
      return "processing";
    case Asset.AssetLifecycleState.QUEUED_FOR_PROCESSING:
      return "processing";
    case Asset.AssetLifecycleState.PROCESSING:
      return "processing";
    case Asset.AssetLifecycleState.READY:
      return "ready";
    case Asset.AssetLifecycleState.FAILED:
      return "error";
    case Asset.AssetLifecycleState.REPROCESSING:
      return "processing";
    case Asset.AssetLifecycleState.DELETED:
      return "deleted";
    case Asset.AssetLifecycleState.TOO_MANY_REQUESTS:
      return "insufficient credits";
    // TODO: @andi Handle other states
    default:
      return "";
    // case AssetLifecycleState.ARCHIVED:
    //   return "Archived";
    // case AssetLifecycleState.QUARANTINED:
    //   return "Quarantined";
    // case AssetLifecycleState.DELETE_REQUESTED:
    //   return "Delete Requested";
  }
};
